// Etiqueta del estado de un archivo: en uso / huérfano / referencia rota.
import React from "react";
import { Tag, Tooltip } from "antd";
import type { EstadoArchivo } from "../../../services/almacenamiento.api";

const CONFIG: Record<EstadoArchivo, { color: string; texto: string; ayuda: string }> = {
  en_uso: {
    color: "green",
    texto: "En uso",
    ayuda: "Algún registro del sistema usa este archivo. Si lo eliminas, desaparece de ese lugar.",
  },
  huerfano: {
    color: "orange",
    texto: "Huérfano",
    ayuda:
      "Ocupa espacio en el disco pero ningún registro del sistema lo usa. Eliminarlo no afecta a nadie.",
  },
  roto: {
    color: "red",
    texto: "Referencia rota",
    ayuda:
      "Un registro apunta a este archivo, pero ya no existe en el disco. Eliminar la referencia limpia el registro.",
  },
};

export const ETIQUETA_ESTADO_ARCHIVO: Record<EstadoArchivo, string> = {
  en_uso: CONFIG.en_uso.texto,
  huerfano: CONFIG.huerfano.texto,
  roto: CONFIG.roto.texto,
};

const EstadoTag: React.FC<{ estado: EstadoArchivo }> = ({ estado }) => {
  const cfg = CONFIG[estado] ?? { color: "default", texto: estado, ayuda: "" };
  return (
    <Tooltip title={cfg.ayuda}>
      <Tag color={cfg.color} style={{ marginInlineEnd: 0 }}>
        {cfg.texto}
      </Tag>
    </Tooltip>
  );
};

export default EstadoTag;
